/**
 * main.tsx
 * Sentriqs
 *
 * Created by: Dylan Knight
 * Copyright (c) 2023 Sentriqs, Inc. All rights reserved.
 *
 */

import { init } from "emoji-mart";
import { createRoot } from "react-dom/client";
import * as React from "react";

import { Root } from "./root";

function initialize (): void {
  init({
    data: async () => {
      return (await fetch("https://cdn.jsdelivr.net/npm/@emoji-mart/data")).json();
    }
  });
  const root = document.getElementById("app-main");
  if (!root) { return; }
  if (document.body) {
    if (window.location.hostname && window.location.hostname.endsWith("glyphapp.io")) {
      if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        document.body.className = "glyph dark-mode";
        document.getElementsByTagName("html")[0].className += " glyph dark-mode";
      } else {
        document.body.className = "glyph light-mode";
        document.getElementsByTagName("html")[0].className += " glyph light-mode";
      }
      window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", event => {
        if (event.matches) {
          document.body.className = "glyph dark-mode";
          document.getElementsByTagName("html")[0].className = "glyph dark-mode";
        } else {
          document.body.className = "glyph light-mode";
          document.getElementsByTagName("html")[0].className = "glyph light-mode";
        }
      })
    } else {
      document.body.className = "securedcomms";
      document.getElementsByTagName("html")[0].className += " securedcomms";
    }
  }
  const cspNonceTag = document.getElementById("csp-nonce");
  const cspNonce = cspNonceTag ? cspNonceTag.getAttribute("content") : "";
  
  createRoot(root).render(<Root cspNonce={cspNonce} />);
  
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initialize);
} else {
  initialize();
}
